import { CardHeader } from "reactstrap";
import { StockResult } from "../../../../Constant";
import { H3 } from "../../../../AbstractElements";
import { STOCK_RESULT_LIST } from "../../../../Data/DataTable/StockResultData";

const StockResultCardHeader = () => {
  return (
    <CardHeader className="pb-0 card-no-border">
      <H3>{StockResult}</H3>
      {STOCK_RESULT_LIST.map((item, index) => (
        <span dangerouslySetInnerHTML={{ __html: item }} key={index}/>
      ))}
    </CardHeader>
  );
};

export default StockResultCardHeader;
